<template>
  <div style="width: fit-content">
    <div style="display: flex">
      <div class="section form-column">
        <el-form
          :disabled="readonly"
          label-width="133px"
          label-position="right"
        >
          <span class="title" />
          <el-form-item :label="$t('CargoMsg.Cargo_CabinSpaceSerialNo')">
            <el-input v-model="cabin.allocationSerialNumber" no="1" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CargoType')">
            <el-select v-model="cabin.cargoType" filterable>
              <el-option
                v-for="(item,index) in cargoType4JobSelect"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
            <div style="display: flex">
              <el-date-picker
                no="etd"
                class="departure-date-picker"
                :value="cabin.etd"
                type="date"
                value-format="yyyy-MM-dd"
                style="flex: 1;margin-right: 5px"
                @input="etdChange"
              />&nbsp;
              <span>{{ cabin.sailingDay|filterWeek }}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('SeaExport.DateOfArrival2') }}</span>
            <div style="display: flex">
              <el-date-picker
                v-model="cabin.eta"
                no="eta"
                style="flex: 1;margin-right: 5px"
                type="date"
                value-format="yyyy-MM-dd"
                @input="etaChange"
              />
              <span>{{ cabin.etaSailingDay|filterWeek }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfReceiptCodeOnBl')">
            <cargo-advance-select
              no="loadingPort"
              :select-type="selectTypeNames.basic_data_Seaport"
              :placeholder="$t('SeaExport.PlaceHolderPOR')"
              filterable
              :default-value="cabin.loadingPort"
              tag-name="englishName"
              style="flex:1"
              @parentCallBack="p=>{changeDispatchingPlaceCode(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfReceiptOnBl')">
            <el-input
              v-model="cabin.dispatchingPlace"
              no="dispatchingPlace"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.PortOfLoading') }}</span>
            <div style="display: flex; justify-content: space-between">
              <cargo-advance-select
                ref="departurePort"
                no="departurePort"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="cabin.departurePort"
                tag-name="englishName"
                style="flex:1"
                @parentCallBack="p => { cabin.departurePort = p.value; setPlannerChange(p.value);}"
              />&nbsp;
              <el-checkbox v-model="cabin.transshipment" no="transfering" style="padding-left:2px;">{{
                $t('SeaExport.Transit')
              }}
              </el-checkbox>
            </div>
          </el-form-item>
          <el-form-item
            v-show="cabin.transshipment"
          >
            <span slot="label" class="blue">{{ $t('SeaExport.TransitPort') }}</span>
            <cargo-advance-select
              no="transferPortCode"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="cabin.transferPortCode"
              @parentCallBack="p=>{cabin.transferPortCode=p.value;}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.PortOfDischarge') }}</span>
            <cargo-advance-select
              no="dischargePort"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="cabin.dischargePort"
              @parentCallBack="p=>{dischargingPortCodeChange(p.value);}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.PlaceOfDelivery') }}</span>
            <cargo-advance-select
              no="deliveryPlace"
              class="port-of-delivery-selector"
              popper-class="port-of-delivery-selector-popper"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="cabin.deliveryPlace"
              @parentCallBack="p=>{cabin.deliveryPlace = p.value}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_PlaceOfDeliveryRegion') }}</span>
            <cargo-advance-select
              no="placeOfDeliveryRegion"
              :select-type="selectTypeNames.basic_data_Region"
              filterable
              :default-value="cabin.placeOfDeliveryRegion"
              @parentCallBack="p=>{cabin.placeOfDeliveryRegion=p.value}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.Airline') }}</span>
            <el-input
              no="vesselLine"
              :value="vesselLine"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.ShippingCompany') }}</span>
            <cargo-company-select
              ref="shippingCompany"
              no="carrierId"
              :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
              :default-value="cabin.carrierId||''"
              @change="p=>{cabin.carrierId=p.value;shippingCompanyChange(p.value);}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BookingAgent')">
            <cargo-advance-select
              no="bookingAgent"
              :select-type="selectTypeNames.basic_data_Company"
              filterable
              :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
              :default-value="cabin.bookingAgent||''"
              @parentCallBack="p=>{cabin.bookingAgent = p.value}"
            />
          </el-form-item>
        </el-form>
      </div>
      <div style="padding-left: 10px" />
      <div class="section form-column" style="width: 400px;">
        <el-form
          :disabled="readonly"
          label-width="105px"
          label-position="right"
        >
          <span class="title">{{ $t('SeaExport.ContainerInfo2') }}</span>
          <booking-sea-eq-data-grid
            ref="bookingSeaEqDataGrid"
            no="bookingSeaEqDataGrid"
            :value="seaEqList"
            :container-load-type="'FCL'"
            :is-edit="!readonly"
            :job="cabin"
            @eqQuantityChange="eqQuantityChangeHandler"
          />
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.OperationCompany') }}</span>
            <cargo-office-select
              no="branchId"
              :office-id="Number(cabin.branchId)"
              @change="p=>{cabin.branchId=p.value;}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.AirlinePerson2')">
            <cargo-user-select
              no="routeManager"
              :method-params="{officeId:cabin.branchId,category:'role',shape:'seaLine'}"
              :default-value="cabin.routeManager||''"
              @change="p=>{cabin.routeManager=p.value;txtPlannerChangeHandler(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CabinSpaceNote')">
            <el-input
              v-model="cabin.allocationNote"
              no="allocationNote"
              type="textarea"
              :rows="4"
              style="width: 285px;"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_GuidedSellingPrice')">
            <el-input v-model="cabin.guideSellingPrice" no="guideSellingPrice" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FreeDemurrage')">
            <el-input-number v-model="cabin.freeStackDays" :controls="false" style="width: 100%;" no="freeStackDays" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FreeDetention')">
            <el-input-number v-model="cabin.freeChestRentPeriod" :controls="false" style="width: 100%;" no="freeChestRentPeriod" />
          </el-form-item>
        </el-form>
      </div>
      <div style="padding-left: 10px" />
      <div class="section form-column" style="width: 400px;">
        <span class="title">{{ $t('SeaExport.BookingInfo') }}</span>
        <el-form
          :disabled="readonly"
          label-width="105px"
          label-position="right"
        >
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.Vessel') }}</span>
            <cargo-advance-select
              no="5"
              :select-type="selectTypeNames.static_data_Vessel"
              :cache="false"
              filterable
              :allow-create="true"
              :default-value="cabin.shipName"
              :static-options="vesselList"
              @parentCallBack="p=>{onVesselSelectionChange(p)}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.Voyage') }}</span>
            <div style="display: flex">
              <cargo-advance-select
                ref="voyage"
                no="6"
                :static-options="voyages || []"
                :cache="false"
                :default-value="cabin.voyage"
                filterable
                clearable
                :allow-create="true"
                tag-name="voyageNo"
                tag-value="voyageNo"
                :filter-tag-names="['voyageNo']"
                @focus="txtVoyageFocusInHandler()"
                @parentCallBack="p=>{onVoyageFlightChange(p)}"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CarrierVoyage')">
            <el-input v-model="cabin.carrierVoyage" no="carrierVoyage" />
          </el-form-item>
          <el-form-item label="S/O No.">
            <so-no-input v-model="cabin.soNo" no="soNo" :disabled="readonly" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MblNo2')">
            <div style="display: flex;flex-direction: row;padding-right: 3px;">
              <el-input v-model="cabin.mblNo" no="7" :class="cabin.mblNo==='CANCELLED'?'mbl-red':''" />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BookingNo')">
            <el-input v-model="cabin.bookingNo" no="9" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')">
            <el-input v-model="cabin.scNo" no="10" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_IMO')">
            <el-input v-model="cabin.imo" no="11" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CarrierCode')">
            <el-input v-model="cabin.shipEdiCode" no="carrierCode" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BookingShipCallSign')">
            <el-input v-model="cabin.shipCallSign" no="12" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode')">
            <el-input v-model="cabin.routeCode" no="13" :disabled="checkRouteCode" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DocCutOffDate')">
            <el-date-picker
              v-model="cabin.cutOffDate"
              no="52"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DeclareCutOffDate')">
            <el-date-picker
              v-model="cabin.declarationDate"
              no="53"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CYCutOffDate2')">
            <el-date-picker
              v-model="cabin.sealingDate"
              no="54"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerCyCutOffDate')">
            <el-date-picker
              v-model="cabin.customerSealDate"
              no="55"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerShutOutDate')">
            <el-date-picker
              v-model="cabin.customerWithdrawalDate"
              no="customerWithdrawalDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerClosingTime')">
            <el-date-picker
              v-model="cabin.customerCutOffTime"
              no="customerCutOffTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CabinSpaceRecord')">
            <el-input
              v-model="cabin.allocationRemark"
              no="allocationRemark"
              type="textarea"
              :rows="4"
              style="width: 285px;"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import { CabinManagement } from '@/class/model/booking/CabinManagement'
import lang from '@/lang'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache, getSpecificBasicData, getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid.vue'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import { loadSpecificBasicInfo } from '@/api/cache'
import { Voyage } from '@/class/model/mdm/Voyage'
import { cache, cacheName } from '@/utils/cacheManager'
import soNoInput from '@/components/Cargo/Job/soNoInput.vue'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import { User } from '@/class/model/sys/User'
import { Vessel } from '@/class/model/mdm/Vessel'
import { TabError } from '@/utils/class/TabError'
import { getMatchedUserPorts } from '@/api/userPort'
import { SE } from '@/class/cargo/model/parameters/SystemConstants'
import { FCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'

export default {
  name: 'TabBasic',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE':
          return lang.t('SeaExport.TUE')
        case 'WED':
          return lang.t('SeaExport.WED')
        case 'THU':
          return lang.t('SeaExport.THU')
        case 'FRI':
          return lang.t('SeaExport.FRI')
        case 'SAT':
          return lang.t('SeaExport.SAT')
        case 'SUN':
          return lang.t('Pricing.Sun')
        case 'MON':
        default:
          return lang.t('SeaExport.MON')
      }
    }
  },
  components: { cargoUserSelect, soNoInput, cargoOfficeSelect, bookingSeaEqDataGrid, cargoCompanySelect, cargoAdvanceSelect },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      cabin: new CabinManagement().fillDefaultValue().getData(),
      selectTypeNames: TYPE_NAMES,
      vesselLine: '',
      currentVessel: null,
      showJudgmentOfVoyageNo: false, // 航次是否显示V.判断
      seaPortList: [],
      regionList: [],
      vesselList: [],
      seaEqList: [],
      voyages: [],
      checkRouteCode: false, // 是否可以编辑航线代码
      cargoType4JobSelect: []
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.seaPortList = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    this.regionList = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
    this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
    this.showJudgmentOfVoyageNo = Number(cache.config.get('JudgmentOfVoyageNo')) === 1
  },
  methods: {
    async onShow(row, isRefresh) {
      const cabin = new CabinManagement(row)
      this.cabin = cabin
      this.seaEqList = cabin.voList = cabin.voList || []
      this.cargoType4JobSelect = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType).filter(p => p.sea)
      if (this.vesselList) {
        this.currentVessel = this.vesselList.filter(p => p.englishName === this.cabin.shipName)[0]
        await this.getVoyageByVessel()
      }
      // 航线
      this.checkVesselLine()
      this.cabin.sailingDay = JobUtils.dateChange(this.cabin.etd)
      this.cabin.etaSailingDay = JobUtils.dateChange(this.cabin.eta)
    },
    async etdChange(value) {
      this.cabin.etd = value
      this.cabin.sailingDay = JobUtils.dateChange(this.cabin.etd)
    },
    async etaChange(value) {
      this.cabin.eta = value
      this.cabin.etaSailingDay = JobUtils.dateChange(this.cabin.eta)
    },
    async changeDispatchingPlaceCode(event) {
      const cabin = this.cabin
      cabin.loadingPort = event.code
      this.changeDispatchingPlace(event.englishName)
    },
    /**
     * 提单发货地
     */
    async changeDispatchingPlace(dispatchingPlace) {
      const cabin = this.cabin
      if (dispatchingPlace) {
        cabin.dispatchingPlace = dispatchingPlace
      }
    },
    async dischargingPortCodeChange(value) {
      const cabin = this.cabin
      if (cabin.dischargePort !== value) {
        cabin.dischargePort = value
        if (Number(cache.config.get('SyncPOD')) === 1) {
          cabin.deliveryPlace = cabin.dischargePort
        } else {
          cabin.deliveryPlace = cabin.deliveryPlace || cabin.dischargePort
        }
        const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
        await this.setPlannerChange(value)
        const port = seaPorts.find(p => p.code === cabin.deliveryPlace)
        cabin.placeOfDeliveryRegion = port ? port.region : ''
      }
      this.checkVesselLine()
    },
    async shippingCompanyChange(value) {
      if (!this.readonly) {
        let region
        if (this.cabin.dischargePort) {
          const port = this.seaPortList.find(p => p.code === this.cabin.dischargePort)
          if (port) {
            region = this.regionList.find(p => p.code === port.region)
          }
        }
        const res = await getMatchedUserPorts({ lob: SE.code, code: this.cabin.dischargePort, region: region ? region.code : '', operateType: FCL_CARGO_TYPE.code, customJobType: '',
          opOffice: this.$store.getters.currentOfficeId, loadingPortCode: this.cabin.departurePort, cargoType: this.cabin.cargoType, carrierId: value,
          consigneeId: 0, cargoSource: '' })
        this.setAirlinePerson(res)
      }
    },
    async setPlannerChange(value) {
      if (!this.readonly) {
        let region
        if (value) {
          const port = this.seaPortList.find(p => p.code === value)
          if (port) {
            region = this.regionList.find(p => p.code === port.region)
          }
        }
        const res = await getMatchedUserPorts({ lob: SE.code, code: value, region: region ? region.code : '', operateType: FCL_CARGO_TYPE.code, customJobType: '',
          opOffice: this.$store.getters.currentOfficeId, loadingPortCode: this.cabin.departurePort, cargoType: this.cabin.cargoType, carrierId: this.cabin.carrierId,
          consigneeId: 0, cargoSource: '' })
        this.setAirlinePerson(res)
      }
    },
    async setAirlinePerson(res) {
      if (res.data.length === 0) {
        return
      }
      const roleUsersMap = new Map()
      for (const { userId, multipleRole } of res.data) {
        const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', userId)
        if (!user) {
          continue
        }
        if (!multipleRole) {
          continue
        }
        const roles = multipleRole.split(',')
        for (const role of roles) {
          const items = role.split('-')
          const roleValue = items[0]
          const isDefault = items[1] === '1'
          let users = roleUsersMap.get(roleValue)
          if (!users) {
            users = []
            roleUsersMap.set(roleValue, users)
          }
          users.push(isDefault ? { ...user, isDefault } : user)
        }
      }
      const manualSelectIfMultiple = Number(cache.hqConfig.get('useUserPortManualSelectIfMultiple')) === 1
      const useUserPortNotUpdate = Number(cache.hqConfig.get('useUserPortNotUpdate')) === 1
      for (const [role, users] of roleUsersMap) {
        let userId = 0
        if (!(users.length > 1 && manualSelectIfMultiple)) {
          const defaultUser = users.find(p => p.isDefault)
          userId = defaultUser ? defaultUser.userId : users[0].userId
        }
        switch (role) {
          case 'seaLine':
          case 'airline':
          case 'railwayLine':
            if (useUserPortNotUpdate) {
              break
            }
            this.cabin.routeManager = userId
            if (userId > 0) {
              await this.txtPlannerChangeHandler({ value: userId })
            }
            break
        }
      }
    },
    checkVesselLine() {
      const cabin = this.cabin
      this.vesselLine = ''
      if (cabin.dischargePort) {
        const port = this.seaPortList.find(p => p.code === cabin.dischargePort)
        if (port) {
          const region = this.regionList.find(p => p.code === port.region)
          this.vesselLine = region ? (this.$store.getters.language === 'zh' ? region.name : region.nameEnglish) : ''
        }
      }
    },
    eqQuantityChangeHandler() {},
    async onVesselSelectionChange(data) {
      this.currentVessel = data
      this.cabin.shipName = data.value
      await this.getVoyageByVessel()
    },
    async getVoyageByVessel() {
      if (this.currentVessel && this.currentVessel.vesselId) {
        this.voyages = await Voyage.getVoyage(this.currentVessel.vesselId)
      } else {
        this.voyages = []
      }
    },
    validateForm() {
      if (!this.cabin.etd) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.DateOfDeparture2')
      }
      if (this.cabin.etd && this.cabin.eta && this.cabin.eta < this.cabin.etd) {
        return this.$t('SeaExport.checkDateOfDepartureAndDateOfArrival')
      }
      if (!this.cabin.departurePort) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.PortOfLoading')
      }
      if (!this.cabin.dischargePort) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.PortOfDischarge')
      }
      if (!this.cabin.deliveryPlace) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.PlaceOfDelivery')
      }
      if (this.cabin.transshipment && !this.cabin.transferPortCode) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.TransitPort')
      }
      if (!this.vesselLine) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.Airline')
      }
      if (!this.cabin.carrierId) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.ShippingCompany')
      }
      if (!this.cabin.branchId) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.OperationCompany')
      }
      if (!this.cabin.shipName) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.Vessel')
      }
      if (!this.cabin.voyage) {
        return this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('SeaExport.Voyage')
      }
      if (!this.cabin.voList || this.cabin.voList.length === 0) {
        return this.$t('CargoMsg.Cargo_CheckBoxSize')
      }
    },
    getSubmitData() {
      const checkMessage = this.validateForm()
      if (checkMessage) {
        throw new TabError(checkMessage, 'tabBasic')
      }
      const cabin = { ... this.cabin._data }
      cabin.deleteVoList = this.cabin.delseaEQUuids
      return cabin
    },
    txtVoyageFocusInHandler() {
      let value = 'V.'
      if (!this.showJudgmentOfVoyageNo) {
        value = ''
      }
      if (this.cabin.voyage) {
        value = this.cabin.voyage
        this.cabin.voyage = ''
      }
      this.$nextTick(() => {
        this.cabin.voyage = value
        const elSelect = this.$refs.voyage.$refs.advanceSelectRef
        const innerInput = elSelect.$children[0].$refs.input
        innerInput.value = this.cabin.voyage
      })
    },
    /**
     * 航线改变
     */
    async txtPlannerChangeHandler(data) {
      const cabin = this.cabin
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'seaLine', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.plannerDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = await User.getUserById(data.value)
          if (user) {
            const dep = await new User(user).getDefaultDepartment('role', 'seaLine')
            cabin.plannerDepartment = dep ? dep.departmentId : 0
          }
        }
      } else {
        cabin.routeManager = 0
        cabin.plannerDepartment = 0
      }
    },
    async onVoyageFlightChange(data) {
      const cabin = this.cabin
      cabin.voyage = data.value
      cabin.routeCode = data.routeCode
      if (data.routeCode) {
        this.checkRouteCode = true
      } else {
        this.checkRouteCode = false
      }
    }
  }
}
</script>
